import { Typography } from '@mui/material';
import DeleteDialog from 'shell/components/shared/delete-dialog';
import TableIdCard from 'front-office/components/retrieve-id-card/list/table-id-card';
import { RetrieveIdCardCrumbs } from 'front-office/constants/retrieve-id-card-crumbs';
import { CmsResponse } from 'front-office/view-models/retrieve-id-card/cms-response';
import { RetrievedIdCard } from 'front-office/view-models/retrieve-id-card/retrieved-id-card';
import { Fragment, useCallback, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __CIE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { HttpResponseList } from 'shell/models/http-response';

const RetrieveIdCardList = (): React.ReactElement => {
  const [cieToDelete, setCieToDelete] = useState<null | RetrievedIdCard>(null);

  const [cie, getCie] = useHttpFetch<HttpResponseList<CmsResponse>, Array<RetrievedIdCard>>(
    `${__CIE_API_URL__}/console`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
      },
      transformer: (response) =>
        (response?.data?.payload?.list || []).map((item) => ({
          code: item.key.codice,
          xmlText: item.testoXml,
        })),
    }
  );

  const deleteCie = useHttpClient(`${__CIE_API_URL__}/console`, {
    options: {
      method: 'DELETE',
    },
  });

  const clearCieToDelete = useCallback(() => setCieToDelete(null), [setCieToDelete]);

  const onDeleteCie = useCallback((): void => {
    if (cieToDelete) {
      (deleteCie({ url: `/${cieToDelete.code}` }) as ResponsePromise<void>).then(() => {
        getCie();
        setCieToDelete(null);
      });
    }
  }, [cieToDelete, deleteCie, getCie, setCieToDelete]);

  return (
    <Fragment>
      <Breadcrumbs items={RetrieveIdCardCrumbs} />
      <div className="pmi-pt-4 pmi-pb-3 pmi-d-flex pmi-align-items-center pmi-justify-content-between">
        <Typography
          color="secondary.main"
          style={{
            fontSize: '26px',
          }}
        >
          Recupero Cartellini CIE
        </Typography>
      </div>
      <div className="pmi-mt-2">
        <TableIdCard
          retrievedIdCards={(cie.data || []) as Array<RetrievedIdCard>}
          onTrashPress={(card) => setCieToDelete(card)}
        />
      </div>
      {Boolean(cieToDelete) ? (
        <DeleteDialog
          isOpen={Boolean(cieToDelete)}
          onAbort={clearCieToDelete}
          onClose={clearCieToDelete}
          onConfirm={onDeleteCie}
        />
      ) : null}
    </Fragment>
  );
};

RetrieveIdCardList.displayName = 'Retrieve id card list page component';

export default RetrieveIdCardList;
